






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaFoto} from '@/model/resource/CargaFoto'
import {InputCargaFotoSchema} from '@/schema/resource/CargaFoto/InputCargaFotoSchema'

@Component
export default class PersistCargaFotoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaFotoSchema()
  cargaFoto = new CargaFoto()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaFoto.getCargaFoto(id)
    }

    $.await.done('getCargaFoto')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaFoto.persistCargaFoto()
    await Helper.successAndPush('system.success.persist', '/carga-foto/list')
  }
}
